import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, TextField } from 'emerald-ui';

class SignUpFormContactInfo extends Component {
  handleChange = (key) => (event) => {
    const value = event.target.value;
    this.props.handleFieldChange({ [key]: value });
  };

  render() {
    const { phone = {}, phoneExt = {}, tollFreePhone = {}, tollFreePhoneExt = {}, fax = {} } = this.props;
    return (
      <Row>
        <Col xs={12} md={5} className="sign-up-form-description">
          <p>Contact info</p>
          <p>Enter the contact info for your company</p>
        </Col>
        <Col xs={12} md={7}>
          <Row className="sign-up-fields-section">
            <Col xs={12} md={8}>
              <TextField
                id="primaryPhone"
                shape="classic"
                placeholder="(333)333-3333"
                label="Primary phone"
                maxLength="14"
                value={phone.value || ''}
                onChange={this.handleChange('phone')}
                error={phone.displayErrors ? phone.errorMsg : ''}
              />
            </Col>
            <Col xs={12} md={4} className="sign-up-form-margin-top-xs">
              <TextField
                id="primaryPhoneExt"
                shape="classic"
                placeholder="123"
                label="Ext (optional)"
                maxLength="5"
                onChange={this.handleChange('phoneExt')}
                value={phoneExt.value || ''}
                error={phoneExt.displayErrors ? phoneExt.errorMsg : ''}
              />
            </Col>
          </Row>
          <Row className="sign-up-fields-section">
            <Col xs={12} md={8}>
              <TextField
                id="tollFreePhone"
                shape="classic"
                placeholder="(333)333-3333"
                label="Toll-free phone"
                maxLength="14"
                onChange={this.handleChange('tollFreePhone')}
                value={tollFreePhone.value || ''}
                error={tollFreePhone.displayErrors ? tollFreePhone.errorMsg : ''}
              />
            </Col>
            <Col xs={12} md={4} className="sign-up-form-margin-top-xs">
              <TextField
                id="tollFreePhoneExt"
                shape="classic"
                placeholder="123"
                maxLength="5"
                label="Ext (optional)"
                onChange={this.handleChange('tollFreePhoneExt')}
                value={tollFreePhoneExt.value || ''}
                error={tollFreePhoneExt.displayErrors ? tollFreePhoneExt.errorMsg : ''}
              />
            </Col>
          </Row>
          <Row className="sign-up-fields-section">
            <Col xs={12}>
              <TextField
                id="fax"
                shape="classic"
                placeholder="(333)333-3333"
                label="Fax"
                maxLength="13"
                onChange={this.handleChange('fax')}
                value={fax.value || ''}
                error={fax.displayErrors ? fax.errorMsg : ''}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

SignUpFormContactInfo.propTypes = {
  handleFieldChange: PropTypes.func,
  phone: PropTypes.object,
  phoneExt: PropTypes.object,
  tollFreePhoneExt: PropTypes.object,
  tollFreePhone: PropTypes.object,
  fax: PropTypes.object,
};

SignUpFormContactInfo.defaultProps = {
  handleFieldChange: () => {},
};

export default SignUpFormContactInfo;



// WEBPACK FOOTER //
// ./src/components/SignUpFormContactInfo/SignUpFormContactInfo.js